import { StaffApiProvider } from '@urbanx/agx.staff.client'
import { AgenciesApiProvider } from '@urbanx/agx.agencies.client'
import { CampaignsApiProvider } from '@urbanx/agx.campaigns.client'
import { DomainApiProvider } from '@urbanx/agx.domain.client'
import { IdentityVerificationApiProvider } from '@urbanx/agx.identityverification.client'
import { MarketingApiProvider } from '@urbanx/agx.marketing.client'
import { PoolsApiProvider } from '@urbanx/agx.pools.client'
import { RealEstateApiProvider } from '@urbanx/agx.realestate.client'
import { RexApiProvider } from '@urbanx/agx.rex.client'
import { RpDataApiProvider } from '@urbanx/agx.rpdata.client'
import { CampaignFlowApiProvider } from '@urbanx/agx.campaignflow.client'
import { CrmApiProvider } from '@urbanx/agx.crm.client'
import { ActivitiesApiProvider } from '@urbanx/agx.activities.client'
import { SupportApiProvider } from '@urbanx/agx.support.client'
import { DocuSignApiProvider } from '@urbanx/agx.docusign.client'

const ApiClients = [
    AgenciesApiProvider,
    CampaignsApiProvider,
    StaffApiProvider,
    RpDataApiProvider,
    CampaignFlowApiProvider,
    CrmApiProvider,
    DomainApiProvider,
    IdentityVerificationApiProvider,
    MarketingApiProvider,
    PoolsApiProvider,
    RealEstateApiProvider,
    RexApiProvider,
    ActivitiesApiProvider,
    SupportApiProvider,
    DocuSignApiProvider,
  ]

export default ApiClients
